import axios from 'axios';
import config from '../../../config';
import { bus } from '@/main';
import { mapGetters } from 'vuex';

const state = {
  notifiche: [],
};

const getters = {
  getNotifiche: () => state.notifiche,
};

const actions = {
  loadNotifiche({ commit }) {
    axios
      .get(config.ROOT_API + '/api/user/notifiche')
      .then(function (response) {
        commit('setNotifiche', response.data);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  createNotificaPush({ dispatch, commit }, newItem) {
    axios
      .post(config.ROOT_API + '/api/user/notifiche', newItem)
      .then(function (response) {
        commit('addNotifica');
        dispatch('loadNotifiche');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  pushNotificaClassifica({ dispatch, commit }, idEvento) {
    axios
      .post(config.ROOT_API + '/api/eventi/' + idEvento + '/classifica/notifica', idEvento)
      .then(function (response) {
        commit('addNotificaClassifica');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  updateNotificaPush({ dispatch, commit }, editItem) {
    // rimuovo l'immagine dall'oggetto associazione perchè è gestita con un servizio apposito
    delete editItem.image;
    axios
      .patch(config.ROOT_API + '/api/user/notifiche/' + editItem.idMessaggio, editItem)
      .then(function (response) {
        commit('editNotifica');
        dispatch('loadNotifiche');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  deleteNotificaPush({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/user/notifiche/' + item.idMessaggio)
      .then(function (response) {
        commit('removeNotifica', response.data);
        dispatch('loadNotifiche');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
  inviaNotificaPush({ dispatch, commit }, item) {
    axios
      .post(config.ROOT_API + '/api/user/sendnotification/', item)
      .then(function (response) {
        commit('sendNotifica', response.data);
        dispatch('loadNotifiche');
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      });
  },
};

const mutations = {
  setNotifiche(mdl, notifiche) {
    state.notifiche = notifiche;
  },

  addNotifica(mdl, rankingPersonale) {
    window.getApp.$emit('NOTIFICA_AGGIUNTA');
    bus.$emit('closeDialog', true);
  },

  addNotificaClassifica(mdl, rankingPersonale) {
    window.getApp.$emit('NOTIFICA_CLASSIFICA');
    bus.$emit('closeDialogRefresh', true);
  },

  editNotifica(mdl, rankingPersonale) {
    window.getApp.$emit('NOTIFICA_MODIFICATA');
    bus.$emit('closeDialog', true);
  },

  removeNotifica(mdl, rankingPersonale) {
    window.getApp.$emit('NOTIFICA_ELIMINATA');
    bus.$emit('closeDialog', true);
  },
  sendNotifica(mdl, rankingPersonale) {
    window.getApp.$emit('NOTIFICA_INVIATA');
    bus.$emit('closeDialog', true);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
